import { Component, OnInit, Output, Input, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MyProfileService } from 'src/app/services/my-profile.service';
import { OrderService } from 'src/app/services/order.service';
import { ArraysHelper } from '../../../helpers/arrays'
import { FormHelper } from '../../../helpers/form.helper';
import { AlertService } from '../../../services/alert.service'
@Component({
  selector: 'app-form-porsche-event',
  templateUrl: './form-porsche-event.component.html',
  styleUrls: ['./form-porsche-event.component.scss']
})
export class FormPorscheEventComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private myProfileService: MyProfileService,
    private orderService: OrderService,
    private arrayHelper: ArraysHelper,
    private formHelper: FormHelper,
    private alertService: AlertService) { }

  public formPorscheOwner!: FormGroup

  public tickets: any[] = []
  public submitted: boolean = false

  @Output() sendPorscheOwner: EventEmitter<any> = new EventEmitter();
  @Input() quantityTickets!: number;
  @ViewChildren('cpfCustomer') cpfCustomer!:  QueryList<any>

  ngOnInit(): void {
    this.formPorscheOwner = this.formBuilder.group({
      'owner': this.formBuilder.array([])
    })


    for (let id = 0; id < this.quantityTickets; id++) {
      let owner = this.formBuilder.group({
        'id': [''],
        'name': ['', [Validators.required, Validators.minLength(5)]],
        'email': ['', [Validators.required, Validators.email]],
        'phone': ['', Validators.required],
        'cpf': ['', Validators.required],
        'additionalInformation': this.formBuilder.group({
          'model': ['', Validators.required],
          'version': ['', Validators.required],
          'yearModel': ['', Validators.required],
          'plate': ['', Validators.required],
          'sizeShirt': ['', Validators.required],
          'question': ['']
        })
      }, {
          // verifica se o cpf é válido, se o nome é completo e se os emails batem
          validators: [this.formHelper.testCpf, this.formHelper.testFullName]
      });
      (this.formPorscheOwner.get('owner') as FormArray).push(owner);

      this.tickets[this.tickets.length] = 'Ingresso'
    }


  }

  getOwner() {
    if (this.formPorscheOwner.status  == 'VALID') {
      this.sendPorscheOwner.emit(true);
      let value = this.arrayHelper.emptyItemRemove(this.formPorscheOwner.value.owner);
     this.orderService.defineAdditionalCustomer(value)
    } else {
       this.alertService.toast({icon: 'error', title: 'Preencha todos os campos', text: 'Alguns campos não estão preenchidos. Por favor, preencha todos os campos necessários corretamente'})
    }
    this.submitted = true;
  }

    /*
      Verifica se tem customer com o cpf informado, s tiver, preenche os campos do formulário em
      que está sendo digitado o cpf, para ser preenchido com as informações do customer
    */
    checkCustomerRegister(eve: any, index: number) {
      //this.loadingUserInformation = true
      this.cpfCustomer.toArray().forEach((cpfCustomer: any, id: number) => {
        if (this.cpfCustomer.toArray()[id].nativeElement.id == index) {
          if (this.cpfCustomer.toArray()[id].nativeElement.value.length == 14) {
            this.myProfileService.checkCustomerRegisterWithCpf(eve.srcElement.value).subscribe((res: any) => {
              if (res.length >= 1) {
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('id')!.setValue(res[0].id));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('name')!.setValue(res[0].name));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('email')!.setValue(res[0].email));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('phone')!.setValue(res[0].phones[0]))
              } else {
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('id')!.setValue(''));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('name')!.setValue(''));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('email')!.setValue(''));
                ((this.formPorscheOwner!.get('owner') as FormArray)!.at(index)!.get('phone')!.setValue(''))
              }
            })
          }
        }
      })
    }

}
